import { Box, Typography, keyframes } from '@mui/material';

const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.06); opacity: 0.85; }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

type BrandLoaderSize = 'default' | 'compact';

interface BrandLoaderProps {
  message?: string | null;
  minHeight?: number | string;
  size?: BrandLoaderSize;
  fullHeight?: boolean;
}

const SIZE_CONFIG = {
  default: { box: 96, logo: 52, gap: 2.5, py: 6 },
  compact: { box: 64, logo: 34, gap: 1.5, py: 2 },
} as const;

const BrandLoader = ({
  message = 'Cargando...',
  minHeight = 320,
  size = 'default',
  fullHeight = false,
}: BrandLoaderProps) => {
  const cfg = SIZE_CONFIG[size];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: fullHeight ? '80vh' : minHeight,
        width: '100%',
        gap: cfg.gap,
        py: cfg.py,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: cfg.box,
          height: cfg.box,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            border: '2px solid',
            borderColor: 'divider',
            borderTopColor: 'primary.main',
            animation: `${spin} 1s linear infinite`,
          }}
        />
        <Box
          component="img"
          src={`${process.env.PUBLIC_URL}/assets/images/logo/vlogo.png`}
          alt="Inversapiens"
          sx={{
            width: cfg.logo,
            height: cfg.logo,
            objectFit: 'contain',
            animation: `${pulse} 1.6s ease-in-out infinite`,
          }}
        />
      </Box>
      {message != null && message !== '' && (
        <Typography
          variant={size === 'compact' ? 'body2' : 'body1'}
          sx={{ color: 'text.secondary', fontWeight: 500, letterSpacing: 0.3 }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default BrandLoader;
